import apiClient from "./ApiClient";

export const saveSalaryRevision = async (salaryRevision) => {
  try {
    const response = await apiClient.post(`/api/SalaryRevision/save`, salaryRevision);
    return {
      success: true,
      message: response.data.msg || "Salary revision saved successfully",
      id: response.data.id
    };
  } catch (error) {
    console.error("Error saving salary revision:", error);
    throw {
      success: false,
      message: error.response?.data?.message || "Failed to save salary revision",
      error
    };
  }
};

export const getSalaryRevisions = async (filter) => {
  try {
    const response = await apiClient.post(`/api/SalaryRevision/get`, filter);
    return response.data;
  } catch (error) {
    console.error("Error fetching salary revisions:", error);
    throw error;
  }
};

// Get employees for dropdown - using existing employee API pattern
export const getEmployeesForDropdown = async () => {
  try {
    const response = await apiClient.post(`/api/Employee/get`, {});
    return response.data.map(emp => ({
      value: emp.employee_Id,
      label: `${emp.employee_Code} - ${emp.employee_NameEn}`,
      employee: emp
    }));
  } catch (error) {
    console.error("Error fetching employees:", error);
    throw error;
  }
};

// Get payroll data for effective date
export const getPayrollData = async () => {
  try {
    const response = await apiClient.post(`/api/Payroll/get`, {});
    return response.data;
  } catch (error) {
    console.error("Error fetching payroll data:", error);
    throw error;
  }
};

// Get employee salary components
export const getEmployeeSalaryComponents = async (employeeId) => {
  try {
    const response = await apiClient.post(`/api/Employee/get`, { employee_Id: employeeId });
    if (response.data && response.data.length > 0) {
      const employee = response.data[0];
      return {
        basicSalary: employee.employee_BS || 0,
        hra: employee.employee_HRA || 0,
        transportAllowance: employee.employee_TA || 0,
        otherAllowance: employee.employee_OA || 0,
        foodAllowance: employee.employee_FoodAllowance || 0,
        communicationAllowance: employee.employee_CommunicationAllowance || 0,
        utilityAllowance: employee.employee_UtilityAllowance || 0,
        grossSalary: employee.employee_GS || 0
      };
    }
    return null;
  } catch (error) {
    console.error("Error fetching employee salary components:", error);
    throw error;
  }
};

// Update employee salary (for approval process)
export const updateEmployeeSalary = async (employeeId, salaryComponents) => {
  try {
    const response = await apiClient.post(`/api/Employee/save`, {
      employee_Id: employeeId,
      employee_BS: salaryComponents.basicSalary,
      employee_HRA: salaryComponents.hra,
      employee_TA: salaryComponents.transportAllowance,
      employee_OA: salaryComponents.otherAllowance,
      employee_FoodAllowance: salaryComponents.foodAllowance,
      employee_CommunicationAllowance: salaryComponents.communicationAllowance,
      employee_UtilityAllowance: salaryComponents.utilityAllowance,
      employee_GS: salaryComponents.grossSalary,
      employee_ModifiedBy: Number(localStorage.getItem("userId")) || 1,
      employee_ModifiedDate: new Date().toISOString()
    });
    return {
      success: true,
      message: response.data.msg || "Employee salary updated successfully"
    };
  } catch (error) {
    console.error("Error updating employee salary:", error);
    throw {
      success: false,
      message: error.response?.data?.message || "Failed to update employee salary",
      error
    };
  }
}; 